// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.J4zP77 {
  background-color: var(--header-divider-color);
  flex-shrink: 0;
}

.JzndkM {
  width: 1px;
  height: 24px;
}

.elbNdG {
  width: 2px;
  height: 32px;
}

.go7ek7 {
  width: 3px;
  height: 40px;
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/components/HeaderDivider/HeaderDivider.module.css"],"names":[],"mappings":"AAAA;EACE,6CAA6C;EAC7C,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,UAAU;EACV,YAAY;AACd","sourcesContent":[".divider {\n  background-color: var(--header-divider-color);\n  flex-shrink: 0;\n}\n\n.dividerSmall {\n  width: 1px;\n  height: 24px;\n}\n\n.dividerMedium {\n  width: 2px;\n  height: 32px;\n}\n\n.dividerLarge {\n  width: 3px;\n  height: 40px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"divider": `J4zP77`,
	"dividerSmall": `JzndkM`,
	"dividerMedium": `elbNdG`,
	"dividerLarge": `go7ek7`
};
module.exports = ___CSS_LOADER_EXPORT___;
